<ion-content class="ion-no-padding">
  <form class="lead-form model-container">
    <ion-header class="model-header ion-no-border ion-padding-horizontal sticky-top bg-white">
      <ion-toolbar class="header-first-toolbar">
        <ion-title class="text-start ion-no-padding title-blue">Bulk Upload {{config?.moduleName}}</ion-title>
        <ion-buttons slot="end" class="ion-no-margin">
          <ion-button (click)="closeModal()" class="unfilled-gray-btn">
            <ion-icon name="close-outline"></ion-icon>
          </ion-button>
        </ion-buttons>
      </ion-toolbar>
    </ion-header>

    <div class="model-content p-2">
      <div class="dashed-line"></div>

      <div class="file-upload-container" *ngIf="currentStep === 1">
        <div class="image-upload-container mt-1">
          <div class="d-flex">
            <label class="upload-label clickable-text" for="bulkUploadInput">
              <ion-icon name="cloud-upload-outline" class="upload-icon"></ion-icon><span class="ms-2">Upload CSV
                File</span>
            </label>
          </div>

          <input id="bulkUploadInput" class="file-upload input d-none" type="file" accept=".csv"
            (change)="onFileUpload($event)">
        </div>
        <div class="mb-2" *ngIf="notesMessage">
            <p class="mb-0 text-danger"><b>Note: </b>{{notesMessage}}</p>
          </div>
        <div class="d-flex justify-content-center">
          <ion-button fill="outline" (click)="downloadSample()">Download Sample CSV</ion-button>
        </div>
      </div>

      <div *ngIf="currentStep === 2">
        <div class="ion-no-padding mb-1">
          <ion-title class="dark-title-sm ion-padding-horizontal py-1 bg-light-gray">Map CSV Columns to
            Properties</ion-title>
        </div>
        <form>
          <div class="mapping-grid-container px-2">
            <ng-container *ngFor="let header of headers">
              <div class="label-container">
                <label>{{ header }}</label>
              </div>

              <select class="select" [(ngModel)]="mapping[header]" name="{{header}}">
                <option [value]="'' || null || undefined">-- Select --</option>
                <option *ngFor="let f of getAvailableProperties(header)" [value]="f.property">{{ f.label }}</option>
              </select>
            </ng-container>
          </div>
        </form>
      </div>

      <div *ngIf="mappedData.length > 0">
        <div class="ion-no-padding mb-1 mt-2">
          <ion-title class="dark-title-sm ion-padding-horizontal py-1 bg-light-gray">Review Data</ion-title>
        </div>
        <div class="table-responsive p-2">
          <table class="table table-bordered table-sm">
            <thead>
              <tr>
                <th *ngFor="let key of mappedData[0] ? (mappedData[0] | keyvalue) : []">
                  {{ key.key }}
                </th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let row of mappedData">
                <td *ngFor="let key of row | keyvalue">
                  {{ key.value }}
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>

    </div>


    <!-- Save button -->
    <div class="model-footer ion-padding-horizontal bg-light-gray">
      <div *ngIf="currentStep === 2">
        <ion-button class="filled-blue-btn" type="submit" (click)="mapAndTransformData()">Map Data & Review</ion-button>
      </div>
      <div *ngIf="mappedData.length > 0">
        <ion-button class="filled-blue-btn" type="submit" (click)="submit()">Submit</ion-button>
      </div>
    </div>
  </form>
</ion-content>